__turbopack_context__.v({
  "authorAvatar": "othZZq_authorAvatar",
  "authorRole": "othZZq_authorRole",
  "footerSplit": "othZZq_footerSplit",
  "kicker": "othZZq_kicker",
  "meta": "othZZq_meta",
  "openInForum": "othZZq_openInForum",
  "postBody": "othZZq_postBody",
});
